// extracted by mini-css-extract-plugin
module.exports = {"overlay":"LoadingOverlay_overlay__rmLQr","content":"LoadingOverlay_content__uAEfh"};